if (!customElements.get("slideshow-component")) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        contents: [".f-slideshow__content-wrapper"],
        selected: ".selected",
        flickity: "flickity-component",
        pageDots: ".flickity-page-dots",
        pageCounter: ".flickity-page-counter"
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.prevIndex = 0;

      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.pointerMoved = false;

      this.handleComponentClick =
        this.handleComponentClick.bind(this);

      this.handlePointerDown =
        this.handlePointerDown.bind(this);

      this.handlePointerMove =
        this.handlePointerMove.bind(this);

      this.handlePointerUp =
        this.handlePointerUp.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.init();
    }

    disconnectedCallback() {
      clearInterval(this.check);

      this.removeEventListener(
        "click",
        this.handleComponentClick
      );

      this.removeEventListener(
        "pointerdown",
        this.handlePointerDown
      );

      this.removeEventListener(
        "pointermove",
        this.handlePointerMove
      );

      this.removeEventListener(
        "pointerup",
        this.handlePointerUp
      );

      this.removeEventListener(
        "pointercancel",
        this.handlePointerUp
      );

      this.removeEventListener(
        "keydown",
        this.handleKeydown
      );
    }

    init() {
      this.check = setInterval(() => {
        this.slider =
          this.domNodes.flickity.slider &&
          this.domNodes.flickity.slider.instance;

        if (
          this.slider &&
          typeof this.slider === "object"
        ) {
          clearInterval(this.check);

          this.removeAttribute("data-media-loading");

          this.slider.on(
            "change",
            this.handleChange.bind(this)
          );

          if (
            this.domNodes.contents &&
            this.domNodes.contents.length
          ) {
            this.domNodes.contents[0].classList.add(
              "selected"
            );
          }

          this.initBannerLinks();
          this.handleScreenChange();
          this.playVideo();

          if (this.domNodes.pageCounter) {
            this.domNodes.flickity.insertBefore(
              this.domNodes.pageCounter,
              null
            );
          }
        }
      }, 100);
    }

    initBannerLinks() {
      /*
       * Escuchamos el clic en todo el componente,
       * no solamente en el slide.
       *
       * Esto permite detectar clics sobre:
       * - la imagen;
       * - el overlay;
       * - el título;
       * - la descripción;
       * - espacios vacíos;
       * - la capa de contenido.
       */

      this.addEventListener(
        "click",
        this.handleComponentClick
      );

      this.addEventListener(
        "pointerdown",
        this.handlePointerDown
      );

      this.addEventListener(
        "pointermove",
        this.handlePointerMove
      );

      this.addEventListener(
        "pointerup",
        this.handlePointerUp
      );

      this.addEventListener(
        "pointercancel",
        this.handlePointerUp
      );

      this.addEventListener(
        "keydown",
        this.handleKeydown
      );

      this.updateClickableState();
    }

    getCurrentSlide() {
      if (
        !this.slider ||
        !this.slider.selectedElement
      ) {
        return null;
      }

      return this.slider.selectedElement;
    }

    getCurrentSlideLink() {
      const currentSlide = this.getCurrentSlide();

      if (!currentSlide) return "";

      return currentSlide.dataset.slideLink || "";
    }

    updateClickableState() {
      const slideLink = this.getCurrentSlideLink();

      if (slideLink) {
        this.classList.add(
          "f-slideshow-wrapper--clickable"
        );

        this.setAttribute(
          "data-current-slide-link",
          slideLink
        );
      } else {
        this.classList.remove(
          "f-slideshow-wrapper--clickable"
        );

        this.removeAttribute(
          "data-current-slide-link"
        );
      }
    }

    handlePointerDown(event) {
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerMoved = false;
    }

    handlePointerMove(event) {
      const movementX = Math.abs(
        event.clientX - this.pointerStartX
      );

      const movementY = Math.abs(
        event.clientY - this.pointerStartY
      );

      if (movementX > 10 || movementY > 10) {
        this.pointerMoved = true;
      }
    }

    handlePointerUp() {
      setTimeout(() => {
        this.pointerMoved = false;
      }, 50);
    }

    isInteractiveElement(target) {
      if (!(target instanceof Element)) return false;

      return Boolean(
        target.closest(
          [
            "a",
            "button",
            "input",
            "select",
            "textarea",
            "label",
            "summary",
            "video",
            "iframe",
            ".flickity-button",
            ".flickity-prev-next-button",
            ".flickity-page-dots",
            ".flickity-page-counter",
            ".f-slideshow__btn",
            "[data-no-slide-link]"
          ].join(",")
        )
      );
    }

    handleComponentClick(event) {
      const slideLink = this.getCurrentSlideLink();

      if (!slideLink) return;

      /*
       * Evita abrir el enlace cuando el usuario
       * arrastra el slideshow.
       */
      if (this.pointerMoved) return;

      /*
       * Flickity también puede indicar que se
       * encuentra arrastrando.
       */
      if (
        this.slider &&
        (
          this.slider.isDragging ||
          this.slider.isPointerDown
        )
      ) {
        return;
      }

      /*
       * Los botones, flechas, dots y enlaces
       * siguen funcionando independientemente.
       */
      if (this.isInteractiveElement(event.target)) {
        return;
      }

      window.location.href = slideLink;
    }

    handleKeydown(event) {
      if (
        event.key !== "Enter" &&
        event.key !== " "
      ) {
        return;
      }

      if (this.isInteractiveElement(event.target)) {
        return;
      }

      const slideLink = this.getCurrentSlideLink();

      if (!slideLink) return;

      event.preventDefault();
      window.location.href = slideLink;
    }

    handleChange(index) {
      const sliderCounterCurrent =
        this.querySelector(
          ".flickity-counter--current"
        );

      const slideContentCurrent =
        this.domNodes.contents[index];

      if (slideContentCurrent) {
        const currentTextColor =
          slideContentCurrent.dataset.textColor;

        if (currentTextColor) {
          this.style.setProperty(
            "--slider-controls-color",
            currentTextColor
          );
        }
      }

      this.domNodes.contents.forEach((item) => {
        item.classList.remove("selected");
      });

      if (this.domNodes.contents[this.prevIndex]) {
        this.domNodes.contents[
          this.prevIndex
        ].classList.add(
          "f-slideshow__content--out"
        );
      }

      if (this.domNodes.contents[index]) {
        this.domNodes.contents[
          index
        ].classList.add("selected");
      }

      setTimeout(() => {
        if (
          this.domNodes.contents[this.prevIndex]
        ) {
          this.domNodes.contents[
            this.prevIndex
          ].classList.remove(
            "f-slideshow__content--out"
          );
        }

        this.prevIndex = index;
      }, 300);

      if (
        this.domNodes.pageCounter &&
        sliderCounterCurrent
      ) {
        sliderCounterCurrent.textContent =
          index + 1;
      }

      this.updateClickableState();
      this.playVideo();
    }

    playVideo() {
      this.pauseAllMedia();

      if (
        !this.slider ||
        !this.slider.selectedElement
      ) {
        return;
      }

      const selectedElm =
        this.slider.selectedElement;

      const deferredMedia =
        selectedElm.querySelector(
          "deferred-media"
        );

      if (!deferredMedia) return;

      deferredMedia.loadContent();

      const youtube =
        deferredMedia.querySelector(
          ".js-youtube"
        );

      const vimeo =
        deferredMedia.querySelector(
          ".js-vimeo"
        );

      const video =
        deferredMedia.querySelector("video");

      if (video) {
        const playPromise = video.play();

        if (
          playPromise &&
          typeof playPromise.catch === "function"
        ) {
          playPromise.catch(() => {});
        }
      }

      if (
        youtube &&
        youtube.contentWindow
      ) {
        youtube.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      }

      if (
        vimeo &&
        vimeo.contentWindow
      ) {
        vimeo.contentWindow.postMessage(
          '{"method":"play"}',
          "*"
        );
      }
    }

    pauseAllMedia() {
      this.querySelectorAll(
        ".js-youtube"
      ).forEach((video) => {
        if (!video.contentWindow) return;

        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      });

      this.querySelectorAll(
        ".js-vimeo"
      ).forEach((video) => {
        if (!video.contentWindow) return;

        video.contentWindow.postMessage(
          '{"method":"pause"}',
          "*"
        );
      });

      this.querySelectorAll(
        "video"
      ).forEach((video) => {
        video.pause();
      });
    }

    handleScreenChange() {
      if (FoxThemeSettings.isMobile) {
        // this.domNodes.flickity.toggleFade();
      }

      document.addEventListener(
        "matchMobile",
        () => {
          // this.domNodes.flickity.toggleFade();
        }
      );

      document.addEventListener(
        "unmatchMobile",
        () => {
          // this.domNodes.flickity.toggleFade(true);
        }
      );
    }
  }

  customElements.define(
    "slideshow-component",
    SlideshowComponent
  );
}